import React, { memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import SwitchDatePage from './SwitchDatePage';
import {
  SWITCH_DATE_INFO,
  WEB_REF_SWITCH_PAYMENT,
  WEB_REF_SWITCH_PAYMENT_FULL
} from '../../utils/constants';
import {
  saveSwitchDateForm,
  oldSignatoriesSelector,
  resetConfirmSwitchError
} from '../../infrastructure/oldSignatories';
import { selectors as caseSelector } from '../../infrastructure/cases';
import { SUBMIT_ENTERPRISE_ERROR } from '../../infrastructure/oldSignatories/reducer';

const SwitchDateSection = memo(function SwitchDateSection({ ...props }) {
  return <SwitchDatePage {...props} />;
});

SwitchDateSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  getBusinessData: PropTypes.object,
  saveSwitchDateForm: PropTypes.func.isRequired,
  isSoleTrader: PropTypes.bool.isRequired,
  switchDateTermsLinkHref: PropTypes.string.isRequired
};

const actionCreators = {
  saveSwitchDateForm,
  resetConfirmSwitchError
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  isSoleTrader: caseSelector.isSoleTrader(state),
  isCurrentAccountSwitch: oldSignatoriesSelector.isCurrentAccountSwitch(state),
  getBusinessData: oldSignatoriesSelector.getBusinessData(state, SWITCH_DATE_INFO),
  switchDateTermsLinkHref: selectors.getPdfByWebReference(
    state,
    getSwitchPdfWebRef(oldSignatoriesSelector.isCurrentAccountSwitch(state))
  ),
  switchDateError: oldSignatoriesSelector.getBusinessData(state, SUBMIT_ENTERPRISE_ERROR)
});

const getSwitchPdfWebRef = isCurrentAccountSwitch =>
  isCurrentAccountSwitch ? WEB_REF_SWITCH_PAYMENT_FULL : WEB_REF_SWITCH_PAYMENT;

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SwitchDateSection);
